document.addEventListener('DOMContentLoaded', function() {
  const addBtns = document.querySelectorAll('.mf-btn-add');

  addBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const productId = this.getAttribute('data-product-id');
      const select = document.getElementById('select-' + productId);
      const variantId = select ? select.value : null;

      if (!variantId) return;

      const originalText = this.innerText;
      this.innerText = '加入中...';
      this.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(res => res.json())
      .then(data => {
        this.innerText = '已加入!';
        
        // 通知 Minimog 更新購物車
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.MinimogEvents && window.MinimogEvents.loadCart) {
            window.MinimogEvents.loadCart();
        }

        setTimeout(() => { 
            this.innerText = originalText; 
            this.disabled = false;
        }, 2000);
      })
      .catch(err => {
        console.error(err);
        this.innerText = '失敗';
        this.disabled = false;
      });
    });
  });
});